window.onload = function() {

	$( document ).ready(function() {


		/*		FUNCIÓN PARA CALCULAR SUBTOTAL AJAX CART POPUP		*/

		$.fn.definePlazo = function (int) {


			if (int < 319300) {
					return 24;		
		    	} else if (int < 517770) {
					return 36;
		    	} else if (int >= 517770) {
					return 48;
		    	}

			//return 24;
		}

		/*		FUNCIÓN PARA LIMPIAR FORMATO		*/

		$.fn.clearFormat = function (string, option1,price) {
			if(option1){
				
				if (string.indexOf(" Meses") > -1){
					var posicionTemporal = string.indexOf(" Meses");
					return parseInt(string.substring(posicionTemporal-2, posicionTemporal))*2;
				} else {
					return $.fn.definePlazo(price);
				}
			} else {
				return parseInt(string.replace('$', '').replace(',', '').replace('.', ''));
			}
		}

		/*		FUNCIÓN PARA FORMATO A DECIMALES		*/

		$.fn.decimalFormat = function (string){
			var arr = string.split('.');
			return arr[0] + '<span class="util-hide">.</span><span class="cents">.' + arr[1]+"</span>";
		}

		/*		FUNCIÓN PARA CORREGIR FORMATO		*/

		$.fn.decimalFormatFix = function (target){
			var tagetSring = $.fn.decimalFormat(Shopify.formatMoney($.fn.clearFormat($(target).text())));
			$(target).html(tagetSring);
		}


		/*		FUNCIÓN PARA AJUSTAR ESTILO HOVER DE TÍTULO DE MENÚ		*/
		$('.titulo-menu-inicial').parent().parent().addClass('titulo-nohover');

		if($('body').hasClass('template-product')){

			/*		FUNCIÓN PARA ACTUALIZAR VALORES QUINCENALES Y PLAZOS		*/
			$.fn.pagoParcial = function (price) {

				if($( 'div.product-options__value.active:contains(" Meses")' ).data('meses')!=null){

					$('div.product-page-info #meses-totales').text($( 'div.product-options__value.active:contains(" Meses")' ).data('meses'));
					$('div.product-page-info p.pago-total-quincenal span#precio-completo').html($.fn.decimalFormat(Shopify.formatMoney(price)));
					$('div.product-page-info div.precio-variable span span').html($.fn.decimalFormat(Shopify.formatMoney(price/($( 'div.product-options__value.active:contains(" Meses")' ).data('meses')*2))));
					$('div.footbar-product__price span.precio-variable span').html($.fn.decimalFormat(Shopify.formatMoney(price/($( 'div.product-options__value.active:contains(" Meses")' ).data('meses')*2))));
				} else {
					$('div.product-page-info #meses-totales').text($('.precio-quincenal').attr('data-js-plazo'));
				}

			};

			// SE IDENTIFICA LAS VARIABLES DE ACUERDO A LOS PLAZOS Y SE GUARDAN EN UNA VARIABLE DATA
			$.each($( 'div.product-page-info div.product-options__value:contains(" Meses")' ), function() {
					$(this).data('meses', parseInt($(this).text().replace(/ Meses/g, '')));

			}).promise().done( function(){ 

			// POSTERIOR AL REGISTRO DE MESES SE REALIZA UNA SOLICITUD PARA OBTENER 
			// UN OBJETO JSON CON LA INFORMACIÓN DEL PRODUCTO

				$.getJSON('/products/'+$('.product-page-main').attr('data-product-handle')+'.js', function(product) {		

					var output = '';
			      	for(var i = 0;i < product.variants.length;i++){

			      		if($('.product-page-main').attr('data-product-variant-id') == product.variants[i].id){
			      			$.fn.pagoParcial(product.variants[i].price);
			      		}
				   
				    	//output += 'id '+ i + ': ' + product.variants[i].id;

				    }

					 //console.log(output);

				});

			} );

		}


		/*		FUNCIÓN PARA ACTUALIZAR VALORES QUINCENALES Y PLAZOS		*/

		$.fn.pagoParcialCollection = function (target, price) {

			$.each(target.find('div.product-options__value:contains(" Meses")'), function() {
					
					if($(this).data('meses')==null){
						$(this).data('meses', parseInt($(this).text().replace(/ Meses/g, '')));
					}

			}).promise().done( function(){ 

				var checkMonths = target.find('div.product-options__value.active:contains(" Meses")').data('meses'),
					cambio = target.find('span.precio-quincenal span');
				cambio.html($.fn.decimalFormat(Shopify.formatMoney(price/(checkMonths*2))));
			});

		};

		/*		FUNCIÓN PARA ACTUALIZAR VALORES QUINCENALES Y PLAZOS		*/

		$.fn.UpdateInicialParcialCollection = function () {

			//console.log('Update');

			$.each($('div.product-collection'), function(){

				var jsonPath = '/products/'+$(this).attr('data-product-handle')+'.js',
					targetId = $(this).attr('data-product-variant-id'),
					targetPrice = 0,
					targetMSI = 0,
					targetHtml = '',
					target = this;

				$.getJSON(jsonPath, function(product,target) {		

					var output = '';
			      	for(var i = 0;i < product.variants.length;i++){

			      		if(targetId == product.variants[i].id){
			      			targetPrice = product.variants[i].price;
			      			targetMSI = $.fn.clearFormat(product.variants[i].title,true,targetPrice);

			      			targetHtml = $.fn.decimalFormat(Shopify.formatMoney(targetPrice/targetMSI));
			      		}
				   
				    }

				}).done(function(response) {

					//console.log(targetPrice);
					$(target).find('span.precio-quincenal').html(targetHtml);

				});

			});

		};

		/*		FUNCIÓN PARA EVALUAR AJAX CART POPUP		*/

		$.fn.ajaxCartPopupUpdate = function (itemData){

			var plazo = 0;

			if(itemData.variant_options.length >= 1){

		      	for(var i = 0;i < itemData.variant_options.length;i++){

		      		if (itemData.variant_options[i].indexOf(" Meses") >= 0){
	      				plazo = parseInt(itemData.variant_options[i].replace(/ Meses/g, ''))*2;
	      			}

	      			if(i == itemData.variant_options.length-1 && plazo == 0){

				    	plazo = $.fn.definePlazo(itemData.price);
				    	
					}	
			    }

		    } else if (plazo == 0){

		    	plazo = $.fn.definePlazo(itemData.price);
		    	
			}	

			return plazo;
		}

		/*		FUNCIÓN PARA CALCULAR SUBTOTAL AJAX CART POPUP		*/

		$.fn.ajaxCartPopupSubtotal = function (target) {

			var subtotal = 0,
				plazoGlobal = 1,
				maxPlazoGlobal = 12;

			$.each($('div.popup-cart-item'), function() {
					
				var plazo = 0,
				pagoRegular = $.fn.clearFormat($(this).find('span.price span').text());
					
				if ($(this).find('div.product-cart__variant').text().indexOf(" Meses") >= 0){

					plazo = $.fn.clearFormat($(this).find('div.product-cart__variant').text(),true);
						
      			} else {
      				
      				plazo = $.fn.definePlazo(pagoRegular);
      				
      				$(this).find('div.product-cart__variant').prepend((plazo/2)+' Meses /');

      			}

      			if (plazo > maxPlazoGlobal){
					maxPlazoGlobal = plazo;
				}

				if(plazo == plazoGlobal || plazoGlobal == 1){
      				plazoGlobal = plazo;
      			} else {
      				plazoGlobal = false;
      			}


      			subtotal += Math.round(pagoRegular/plazo);
      			$(this).find('span.price span').html($.fn.decimalFormat(Shopify.formatMoney(pagoRegular/plazo)));		

			}).promise().done( function(){ 

				console.log(maxPlazoGlobal);


				
				if(!plazoGlobal){
					// $('.popup-total-quincenal').removeClass('util-hide');
					$('.popup-cart__content .info-pase').removeClass('util-hide');
  					//$('div.popup-cart__buttons .btn').addClass('medium-opacity').click(function (e){ e.preventDefault(); });
				}else{
					//$('.popup-total-quincenal').addClass('util-hide');
					$('.popup-cart__content .info-pase').addClass('util-hide');
  					//$('div.popup-cart__buttons .btn').removeClass('medium-opacity').unbind('click');
				}

				$('.popup-total-quincenal span.price').html($.fn.decimalFormat(Shopify.formatMoney(subtotal)));


				$.fn.decimalFormatFix('#popup-cart-total span');
				
			});
		};

		$.fn.CartQuincenal = function () {

			////	PRODUCTS FORMAT AND PAYMENT AMOUNTS CORRECTION	////

			var plazoGlobal = 1,
				totalQuincenal = 0,
				maxPlazoGlobal = 12,
				productCount = 0;

			$.each($('div.item-quincenal'), function() {

				productCount += parseInt($(this).find('input').val());

				var pagoRegular = $.fn.clearFormat($(this).find('div.pago-quincenal span.price span').text());
					
				if ($(this).find('p.opciones-quincenal').text().indexOf(" Meses") >= 0){

					var plazo = $.fn.clearFormat($(this).find('p.opciones-quincenal').text(),true);
						
      			} else {
      				var plazo = $.fn.definePlazo(pagoRegular);
      			}

      			if (plazo > maxPlazoGlobal){
					maxPlazoGlobal = plazo;
				}

      			var pagoQuincenal = Shopify.formatMoney(parseInt($(this).find('input').val())*(pagoRegular/plazo));
      			totalQuincenal += parseInt($(this).find('input').val())*(pagoRegular/plazo);
      			$(this).find('.pago-quincenal span.price span').html(pagoQuincenal+'<br><span class="cart-quincenal-text danger-text">x'+plazo+' QUINCENAS</span>');
      			$(this).find('.pago-quincenal').removeClass('null-opacity');

      			if(plazo == plazoGlobal || plazoGlobal == 1){
      				plazoGlobal = plazo;
      			} else {
      				plazoGlobal = false;
      			}

				$.each($(this).find('span.price span'), function() {
      				$.fn.decimalFormatFix($(this));
      			});

  			}).promise().done( function(){ 

  				if(plazoGlobal){
  					//$('.monto-quincenal').removeClass('util-hide');
  				} else {
  					$('.cart__sidebar .info-pase.multiplazos').removeClass('util-hide');
  					//$('#finalizar-quincenal').prop( 'disabled', true );
  					//$('#container-terminos').addClass('util-hide');
  				}

  					$('.monto-quincenal').removeClass('util-hide');
  					$('h3.monto-quincenal').html(Shopify.formatMoney(totalQuincenal));
  					$('p.monto-quincenal span').text(maxPlazoGlobal);
  					$('span#productCount').text(productCount);

  					if (productCount < 2) {
  						$('span#plural').addClass('util-hide');
  					}

      				$.fn.decimalFormatFix($('#subtotal-quincenal'));
      				$.fn.decimalFormatFix($('#total-quincenal'));


			});

  			////	TERMS AND CONDITIONS	////

  			$('body').on('click', '[name="checkout"]', function() {
		      if ($('#terminos').is(':checked')) {
		        $(this).submit();
		      } else {
		        $('.warning-pase.terminos').removeClass('util-hide');
		        $('#finalizar-quincenal').prop('disabled', true);
		        return false;
		      }
		    });

		    $('#terminos').change( function(){
		    	if(this.checked) {
		    		$('.warning-pase.terminos').addClass('util-hide');
		    		$('#finalizar-quincenal').prop('disabled', false);
		    	} else{
		    		$('.warning-pase.terminos').removeClass('util-hide');
		    		$('#finalizar-quincenal').prop('disabled', true);
		    	}
		    });
		};

		if($('body').hasClass('template-cart')){
			$.fn.CartQuincenal();
		}

		//$.fn.UpdateInicialParcialCollection();

		if($( 'body' ).attr('data-js-usuario') == 'Celex'){
			console.log('USUARIO CELEX!');
		}

	});
	
};

